import TimeIndicator from './TimeIndicator';

export default TimeIndicator;
